import Vue from 'vue';

Vue.component('loyalty-category-index', () =>
    import(/* webpackChunkName: 'loyalty-category-index' */ './loyalty-category-index.vue'),
);
